<template>
  <div>
    <div v-if="loading">Loading ...</div>
    <div v-else>
      <div class="margin-bottom border-bottom small-padding-bottom flex">
        <MaterialToggle v-model="reverse" label="Reverse" class="margin-right" />
        <MaterialToggle v-model="show_times" label="Intervals" />
        <MaterialToggle v-model="show_calls" label="Calls" />
      </div>

      <div class="order-history-events">
        <div v-for="(event, e) in events" class="order-history-event">
          <div v-if="show_times && timing(e).length" class="flex order-history-interval">
            <div class="parts">
              <div v-for="part in timing(e)" class="part">{{ part.number }} {{ part.unit }}</div>
            </div>
          </div>

          <div class="order-history-event-content">
            <div class="icon">
              <SvgIcon :name="getIcon(event)" />
            </div>
            <div>
              <div>{{ getDescription(event) }}</div>

              <div class="note">
                <Format type="date" :time="true" :value="event.date.date_time" />

                <template v-if="event.commit.by == 'system'">By system</template>
                <template
                  v-else-if="event.commit.by == 'customer_service'"
                >By {{ event.commit.internal_user.shortened_name }}</template>
                <template
                  v-else-if="event.commit.by == 'customer'"
                >By {{ event.commit.customer.full_name }} (customer)</template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  props: ['id'],
  data: () => ({
    data: {},
    loading: false,
    reverse: false,
    show_times: true,
    show_calls: true
  }),
  computed: {
    events () {
      var list = []

      for (var event of this.data.events) {
        if (this.allow(event)) {
          list.push(event)
        }
      }

      if (this.reverse) {
        return list.reverse()
      } else {
        return list
      }
    }
  },
  methods: {
    /**
     * [allow description]
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    allow (event) {
      var callEvents = [
        'call:booked',
        'call:transfered',
        'call:rescheduled',
        'call:cancelled'
      ]

      if (!this.show_calls && callEvents.indexOf(event.event) >= 0) {
        return false
      }

      return true
    },

    /**
     * [timing description]
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    timing (index) {
      if (index) {
        var last = new Date(this.events[index - 1].date.date_time).getTime()
        var current = new Date(this.events[index].date.date_time).getTime()
        var secondsLeft = Math.abs((last - current) / 1000)
        var factor = 1
        var list = []
        var definitions = [
          {
            divisor: 60,
            unit: ['min', 'mins']
          },
          {
            divisor: 60 * 60,
            unit: ['hr', 'hrs']
          },
          {
            divisor: 24 * 60 * 60,
            unit: ['day', 'days']
          }
        ].reverse()

        for (var d in definitions) {
          var definition = definitions[d]
          var number = Math.floor(secondsLeft / definition.divisor)

          secondsLeft -= number * definition.divisor

          if (number) {
            list.push({
              number: Math.round(number),
              unit: number == 1 ? definition.unit[0] : definition.unit[1],
              base_unit: definition.unit[0]
            })
          }
        }

        return list
          .filter(row => row.number > 0)
          .filter(row => row.base_unit != 'min' || row.number > 10)
          .splice(0, 2)
      }

      return false
    },
    load () {
      Vue.$api.get(
        '/customer/' + this.id + '/history',
        {},
        {
          loader: toggle => (this.loading = toggle),
          callback: data => this.parse(data)
        }
      )
    },
    parse (data) {
      this.data = data
    },
    getIcon (event) {
      switch (event.event) {
        case 'call:booked':
          return 'call'
        case 'call:transfered':
          return 'exchange'
        case 'call:rescheduled':
          return 'date'
        case 'call:cancelled':
          return 'call-cancelled'
        case 'shipping:address-changed':
        case 'shipping:parcelshop-changed':
          return 'shipment'
        case 'discount:received':
          return 'discount'
        default:
          return 'info'
      }
    },
    getDiscountSource (source) {
      switch (source.source) {
        case 'subscription-cost-service:customer-bought-nothing':
          return 'because nothing was returned on ' + source.source_order_id
        case 'dashboard:create-discount':
          return 'by customer service (via Dashboard)'
        case 'subscription-service:prechurn-renewal':
          return 'when renewing their subscription, because she didn\'t keep anything in her latest box'
        case 'subscription-service:prevent-cancel:dont-need-more-clothes':
        case 'subscription-service:prevent-cancel:finances':
        case 'subscription-service:prevent-cancel:other-reason':
          return 'when they were about to cancel their subscriptoin, but opted to receive a discount'
        default:
          return 'because of ' + source.source
      }
    },
    getDiscountType (discount) {
      switch (discount.type) {
        case 'free_styling':
          return 'free styling'
        case 'fixed':
          return discount.value + ' reduction'
        case 'percentage':
          return discount.value + '%'
        default:
          return 'UNKNOWN ' + discount.type
      }
    },
    getEventBase (event) {
      switch (event.event) {
        case 'subscription:created':
          return 'Subscribed'
        case 'discount:received':
          var p1 = JSON.parse(event.parameters[1])
          var p2 = JSON.parse(event.parameters[2])
          return 'Promised discount of {discount} (#{id}) {source}'
            .replace(/{discount}/g, this.getDiscountType(p1))
            .replace(/{id}/g, p1.id)
            .replace(/{source}/g, this.getDiscountSource(p2))
        case 'call:booked':
          return 'Call booked for [parameter_2] (#[parameter_1])'
        case 'call:transfered':
          return (
            'Call transfered from ' +
            event.objects.stylist[1].shortened_name +
            ' to ' +
            event.objects.stylist[2].shortened_name
          )
        case 'order:manual-order':
          return 'Manually ordered new box ([parameter_1])'
        case 'call:rescheduled':
          return 'Rescheduled call from [parameter_2] to [parameter_3]'
        case 'call:cancelled':
          return 'Call cancelled (#[parameter_1])'
        case 'shipping:address-changed':
          return (
            'Default shipping address changed to: [parameter_1]. ' +
            (Number(event.parameters[2]) == 1
              ? 'Propagated to open orders.'
              : 'NOT propagated to open orders.')
          )
        case 'shipping:parcelshop-changed':
          return (
            'Default parcelshop changed to: [parameter_1]. ' +
            (Number(event.parameters[2]) == 1
              ? 'Propagated to open orders.'
              : 'NOT propagated to open orders.')
          )
        default:
          return event.event
      }
    },
    getDescription (event) {
      return this.getEventBase(event)
        .replace('[parameter_1]', event.parameters[1])
        .replace('[parameter_2]', event.parameters[2])
        .replace('[parameter_3]', event.parameters[3])
    }
  },
  created () {
    this.load()
  }
}
</script>

<style lang="less">
.order-history-events {
  position: relative;
  &::after {
    top: 0px;
    bottom: 0px;
    left: @side-padding + 25px;
    width: 2px;
    background: #ddd;
    content: "";
    position: absolute;
  }
  @side-padding: 120px;
  .order-history-event {
    padding-left: @side-padding;
    .order-history-event-content {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 50px;
        position: relative;
        margin-right: 15px;
        flex-grow: 0;
        flex-shrink: 0;
        .svg-icon,
        svg {
          position: relative;
          z-index: 150;
          width: 28px !important;
          height: 28px !important;
          fill: #888;
        }
        &::after {
          top: 0px;
          left: 0px;
          bottom: 0px;
          right: 0px;
          border: 2px solid #ddd;
          border-radius: 6px;
          position: absolute;
          content: "";
          z-index: 100;
          background: #fff;
        }
      }
    }
    .order-history-interval {
      position: relative;
      margin-top: -10px;
      margin-bottom: 10px;
      font-size: 14px;
      color: #999;
      left: -@side-padding;
      .parts {
        border-radius: 4px;
        z-index: 100;
        display: inline-flex;
        padding-right: 10px;
        background: #fff;
        .part {
          position: relative;
          margin-right: 10px;
          background: #fff;
          &:last-child {
            margin-right: 0px;
          }
        }
      }
      &::after {
        z-index: 50;
        position: absolute;
        left: 0px;
        top: 9px;
        height: 2px;
        background: #ddd;
        width: @side-padding + 25px;
        content: "";
      }
    }
  }
}
</style>
